import { GAAdditionalServicesEffects } from './ga.additional.services.effect';
import { GACompleteOrderEffects } from './ga.complete.order.effect';
import { GAConfirmationEffects } from './ga.confirmation.effect';
import { GAOffersEffects } from './ga.offers.effect';
import { GAProductDetailsEffects } from './ga.product.details.effect';
import { GATipsEffects } from './ga.tips.effect';
import { GAUpsellEffects } from './ga.upsell.effect';

export const AnalyticsEffects = [
  GAOffersEffects,
  GAProductDetailsEffects,
  GAAdditionalServicesEffects,
  GACompleteOrderEffects,
  GAConfirmationEffects,
  GATipsEffects,
  GAUpsellEffects,
];

export * from './ga.additional.services.effect';
export * from './ga.complete.order.effect';
export * from './ga.confirmation.effect';
export * from './ga.offers.effect';
export * from './ga.product.details.effect';
export * from './ga.tips.effect';
export * from './ga.upsell.effect';
